import React from 'react';
import { WorkspaceProps } from 'common/types/search';
import { ReactComponent as MobileFilterIcon } from "../../../../../assets/icons/redesign_mobile_filter_icon.svg";
import { ReactComponent as CloseIcon } from '../../../../../assets/icons/close.svg'
import styles from './MobileFilter.module.scss';
import SideFilters from '../SideFilters/SideFilters';
import { screenStore } from 'stores/ScreenStore';
import { viewStore } from 'stores/ViewStore';

interface DurationProps {
  onDurationChange: (index: number, reset?: boolean) => void;
}

interface AllFilterProps {
  fetchData: Function;
}

type MobileFilterProps = WorkspaceProps & DurationProps & AllFilterProps;


const MobileFilter: React.FC<MobileFilterProps> = ({
  onWorkspaceHandler,
  onDurationChange,
  fetchData,
}) => {
  const [isFilterVisible, setIsFilterVisible] = React.useState(false);
  const {isTablet} = screenStore;
  const {view} = viewStore;

  React.useEffect(() => {
    if (isFilterVisible) {
      const originalStyles = {
        overflow: document.body.style.overflow,
      };
      document.body.style.overflow = 'hidden';
      // document.body.style.paddingRight = '15px';

      return () => {
        document.body.style.overflow = originalStyles.overflow;
        // document.body.style.paddingRight = '0';
      };
    }

    return () => {};
  }, [isFilterVisible]);

  const showFilterPopup = () => {
    setIsFilterVisible(true);
    const container = document.getElementById('filters_container');
    if (container) {
      container.style.zIndex = '1001';
    }
  };

  const handleBackgroundClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setIsFilterVisible(false);
    const container = document.getElementById('filters_container');
    if (container) {
      container.style.zIndex = '1000'; // unset
    }
  };

  return (
    <button className={isFilterVisible ? styles.container_active : styles.container} data-testid="filter-toggle-button" onClick={showFilterPopup} type="button">
      <MobileFilterIcon />
      Filters
      {isFilterVisible && (
        <div className={styles.background} onClick={handleBackgroundClick}>
          <div className={styles.sideFiltersContainer}
          onClick={(e) => {
            e.stopPropagation();
          }}
          style={{ top: view === 'map' &&  isTablet ? '-70px' : ''}}
          >
            <div className={styles.sideFiltersHeader}>
              <span>Filters</span>
              <button
                className={styles.closeButton}
                onClick={() => setIsFilterVisible(false)}
                type="button"
              >
              <CloseIcon className={styles.closeIcon} />
            </button>
          </div>
            <SideFilters onWorkspaceHandler={onWorkspaceHandler} fetchData={fetchData} handleDurationSelection={onDurationChange} />
          </div>
        </div>
      )}
    </button>
  );
};

export default MobileFilter;
